import { render } from "./CeibaServer.vue?vue&type=template&id=718b0c3e"
import script from "./CeibaServer.vue?vue&type=script&lang=js"
export * from "./CeibaServer.vue?vue&type=script&lang=js"
script.render = render

export default script